import React, { useMemo } from 'react'
import ChartWrapper, { ChartProps } from '../Common/ChartWrapper'
import GenericBinarySrcGraph from '../../GeneralBinarySrcGraph/GenericBinarySrcGraph'
import commandPlugin from '../../GeneralBinarySrcGraph/plugins/command'
import { Workshift } from '@mv-submodules/inplant-plantanalysis-fe-iblu/types/workshift'
import { mvDate } from '@mv-submodules/mvlabs-components-fe/functions/helpers'
import { ALL_DAY_WORKSHIFT_VALUE } from '@mv-submodules/inplant-plantanalysis-fe-iblu/functions/workshift'
import { baseMetricsPluginForSG1AssetWithInverter } from '../../GeneralBinarySrcGraph/plugins/baseMetricsForSG1'
import bunkerWorkingModePlugin from '../../GeneralBinarySrcGraph/plugins/bunkerWorkingMode'

function _Content(props: ChartProps & { plant: string; workShift: Workshift }) {
  const { component, plant, workShift } = props

  /**
   * Showing bunkers always as full day workshift has been requested by the customer [#32075](https://pm.mvlabs.it/issues/32075)
   * TODO. this is an hack. REMOVE IT IF POSSIBLE. Refactor influx fetch functions to accept a startDate and endDate instead of a workshift.
   */
  const _workShift: Workshift = useMemo(
    () => ({
      ...workShift,
      start: mvDate.startOfDay(mvDate.getDateFromString(workShift.start)).toISOString(),
      end: mvDate.endOfDay(mvDate.getDateFromString(workShift.end)).toISOString(),
      value: ALL_DAY_WORKSHIFT_VALUE,
    }),
    [workShift]
  )

  const plugins = useMemo(() => {
    const _plugins = [commandPlugin]
    if (component.nodeType.includes('INVERTER')) {
      _plugins.push(baseMetricsPluginForSG1AssetWithInverter)
      _plugins.push(bunkerWorkingModePlugin)
    }
    return _plugins
  }, [])

  return (
    <GenericBinarySrcGraph
      id={component.id}
      plant={plant}
      workShift={_workShift}
      plugins={plugins}
      measures={[
        {
          slug: 'running',
          id: 'BS_RUN',
          representation: null,
        },
        {
          slug: 'bunkerFull',
          id: 'BS_MAT_LEV_FULL_DLY',
          representation: 'time-bar',
        },
        {
          slug: 'emptyingCycleActive',
          id: 'BS_DISCH_RUN',
          representation: 'line',
          unitOfMeasurement: "Svuotamento",
          type: "boolean",
        },
      ]}
    />
  )
}

function BunkerChart(props: ChartProps) {
  const { currentGraph, component, toggleCollapse } = props
  return (
    <ChartWrapper currentGraph={currentGraph} component={component} toggleCollapse={toggleCollapse}>
      {({ plant, workShift }) => {
        return <_Content {...props} plant={plant} workShift={workShift} />
      }}
    </ChartWrapper>
  )
}

export default BunkerChart
